import { MapActionKey, MapActionsConfig, MapActionState } from '@ivy-monorepo/shared'
import MapActionIcon from './MapActionIcon'
import MapActionCenterPill from './MapActionCenterPill'

type MapActionsPhonePreviewProps = {
  items: MapActionsConfig
  selectedKey: MapActionKey | null
  onSelect: (key: MapActionKey | null) => void
}

/** The sidebar as the app draws it: hidden filters are left out, disabled ones dimmed. */
const MapActionsPhonePreview = ({ items, selectedKey, onSelect }: MapActionsPhonePreviewProps) => {
  const visible = items.filter(item => item.state !== MapActionState.Hidden)
  const selected = items.find(item => item.key === selectedKey && item.state === MapActionState.Active) ?? null

  return (
    <div className="map-actions-phone">
      <div className="map-actions-phone__label">App preview</div>
      <div className="map-actions-phone__screen">
        <div className="map-actions-phone__sidebar">
          {visible.length === 0 ? <div className="map-actions-phone__empty">All hidden</div> : null}
          {visible.map(item => {
            const disabled = item.state === MapActionState.Disabled
            return (
              <button
                type="button"
                key={item.key}
                title={disabled ? `${item.label} (disabled)` : item.label}
                className={[
                  'map-actions-phone__action',
                  item.key === selected?.key ? 'is-selected' : '',
                  disabled ? 'is-disabled' : '',
                ].join(' ')}
                onClick={() => {
                  if (disabled) return
                  onSelect(item.key === selectedKey ? null : item.key)
                }}
              >
                <MapActionIcon item={item} />
              </button>
            )
          })}
        </div>
        <div className="map-actions-phone__pill-slot">
          {selected ? (
            <MapActionCenterPill item={selected} />
          ) : (
            <span className="map-actions-phone__hint">Tap a filter to preview its pill</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default MapActionsPhonePreview
